export const CONTENT_CONFIG = {

  //******************************************************************LOGIN PAGE******************************************
  
    // TagLine
    tagline:
    "An effective tool and operating system to manage your customers lifecycle.",
  
      // Gretting Text
      greeTingtext:{
        text:'Welcome To '
      },
      
      //  + 
  
      // companyNameColorClass
      //color class is default class, to execute colorcode , add a value in colorCode and make colorclass as empty string
      companyNameColorClass:{
        colorClass: 'text-success',
        colorCode:'#00000'
      },
      
      // CompanyName
      companyName:{
        unity:'Unity Wireless',
        mingle:'Mingle Mobile'
      },
      // Login page Logos
      logos: {
        unityLogo:  "assets/images/logo/logo.png",
        mingleLogo: "assets/images/logo/mingle.png",
      },
  
      altTextForLogo:{
        unity:'Unity Wireless',
        mingle:'Mingle Mobile'
      },
       // Notice
       notice: ` You are going to enter a system owned by Unity Wireless, Inc. The information on this computer system is for official use only. This system can only be accessed by authorized users. 
       Federal or state criminal laws may be broken by unauthorized access to, use of, or modification of this computer system, the data it contains, or the data while it is being transferred to or from this system. Administrative penalties, fines, or imprisonment may be imposed on anyone who gains unauthorized access to a computer system, exceeds their authorized access authority, obtains, alters, damages, destroys, or discloses information, or obstructs authorized use of the system's data.`,
    
    
      // Login page footer Logos
      footerlogos: {
        unityLogo: "assets/images/logo/logo.png",
        mingleLogo: "assets/images/logo/mingle.png",
      },
  
      footerlogosAlttext:{
        unity:'Unity Wireless',
        mingle:'Mingle mobile'
      },
  //*************************************************************LANDING PAGE (HOME PAGE --> /dashboard)********************************************
  
    companyLogoIcons:{
  
      //landing page header logo (Home page)
      unityIcon :'https://unitywireless.com/cdn/shop/files/unitywireless_04e7d271-53f8-4f14-835f-87ed2d976778_32x32.webp?v=1688574366',
      mingleIcon: 'https://www.minglemobile.com/cdn/shop/t/57/assets/favicon.svg?v=178931131784370144781732655519',
  
  
      //  tooltip
  
      unityIconToolTip:'Switch to Mingle',
      mingleIconTooltip:'Switch to Unity',
      // landing sidebar logo (Home page)
  
      unityLogo: 'assets/images/logo/unity_logo.png',
      mingleLogo: 'assets/images/logo/mingle.png',
  
      //  
    },
  
  //********************************************************APPLICATION TITLE************************************************************************* 
  
  // TITLE
    companyTabTitle:{
      unityTitle:'Unity Wireless',
      mingleTitle:'Mingle Mobile'
    },
  
    // LOGO
    companyTabLogo:{
      unityLogo: 'assets/images/logo/unity_logo.png',
      mingleLogo: 'assets/images/logo/mingle.png',
    }
  
  };
  
  
  // edge-demo-v01